const middleware = {}

middleware['authroute'] = require('../middleware/authroute.js')
middleware['authroute'] = middleware['authroute'].default || middleware['authroute']

middleware['exbt-preview-redirect'] = require('../middleware/exbt-preview-redirect.js')
middleware['exbt-preview-redirect'] = middleware['exbt-preview-redirect'].default || middleware['exbt-preview-redirect']

middleware['mobileRedirect'] = require('../middleware/mobileRedirect.js')
middleware['mobileRedirect'] = middleware['mobileRedirect'].default || middleware['mobileRedirect']

middleware['noSessionRoute'] = require('../middleware/noSessionRoute.js')
middleware['noSessionRoute'] = middleware['noSessionRoute'].default || middleware['noSessionRoute']

middleware['seoMeta_backup'] = require('../middleware/seoMeta_backup.js')
middleware['seoMeta_backup'] = middleware['seoMeta_backup'].default || middleware['seoMeta_backup']

middleware['seoMeta'] = require('../middleware/seoMeta.js')
middleware['seoMeta'] = middleware['seoMeta'].default || middleware['seoMeta']

middleware['seoMeta/category'] = require('../middleware/seoMeta/category.js')
middleware['seoMeta/category'] = middleware['seoMeta/category'].default || middleware['seoMeta/category']

middleware['seoMeta/faq'] = require('../middleware/seoMeta/faq.js')
middleware['seoMeta/faq'] = middleware['seoMeta/faq'].default || middleware['seoMeta/faq']

middleware['seoMeta/home'] = require('../middleware/seoMeta/home.js')
middleware['seoMeta/home'] = middleware['seoMeta/home'].default || middleware['seoMeta/home']

middleware['seoMeta/product'] = require('../middleware/seoMeta/product.js')
middleware['seoMeta/product'] = middleware['seoMeta/product'].default || middleware['seoMeta/product']

middleware['seoMeta/search'] = require('../middleware/seoMeta/search.js')
middleware['seoMeta/search'] = middleware['seoMeta/search'].default || middleware['seoMeta/search']

middleware['token'] = require('../middleware/token.js')
middleware['token'] = middleware['token'].default || middleware['token']

export default middleware
